import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getOpportunityTeamMemberListData,
  processAfterAddOrChangeToOpportunityTeamMemberListData,
  processAfterDeleteOfOpportunityTeamMemberListData,
} from './mockData'

const postOpportunityTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getOpportunityTeamMemberListData,
    processAfterAddOrChangeToOpportunityTeamMemberListData
  )
}

const patchOpportunityTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOpportunityTeamMemberListData, [
    processAfterAddOrChangeToOpportunityTeamMemberListData,
  ])
}

const deleteOpportunityTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getOpportunityTeamMemberListData,
    processAfterDeleteOfOpportunityTeamMemberListData
  )
}

export const handlers = [
  {
    method: 'post',
    path: '/api/opportunityteammembers',
    handler: postOpportunityTeamMember,
  },
  {
    method: 'patch',
    path: '/api/opportunityteammembers/:id',
    handler: patchOpportunityTeamMember,
  },
  {
    method: 'delete',
    path: '/api/opportunityteammembers/:id',
    handler: deleteOpportunityTeamMember,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
